import { render, staticRenderFns } from "./S2View.vue?vue&type=template&id=ab7df78a&scoped=true&"
import script from "./S2View.vue?vue&type=script&lang=js&"
export * from "./S2View.vue?vue&type=script&lang=js&"
import style0 from "./S2View.vue?vue&type=style&index=0&id=ab7df78a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7df78a",
  null
  
)

export default component.exports